
import React from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';
import { DashboardTransacFiltersQueryParams } from '../hook/useDashboardTransactionFilters';
import {MerchantBranchSelector} from "../../../components/MerchantBranchSelector";

interface DashboardFiltersProps extends FlexProps {
  onUpdateFilters: (value: string | undefined, key: keyof DashboardTransacFiltersQueryParams) => void;
  queryParams: DashboardTransacFiltersQueryParams;
}

const DashboardFilters = ({ onUpdateFilters, queryParams, ...flexProps }: DashboardFiltersProps) => {

  return (
    <Flex flexWrap="wrap" {...flexProps}>
      <MerchantBranchSelector
        idBranch={queryParams?.idBranch}
        idMerchant={queryParams?.idMerchant}
        handleUpdate={(key, value) => onUpdateFilters(value, key)}
      />
    </Flex>
  )
}

export default DashboardFilters
